import {observable, action, runInAction} from 'mobx'
import {json, _encodeParam} from "../../../utils/ajax";
import {message} from 'antd'
import {handleSearchAndPage, setStore, ValueObjToObj} from "../../../utils/Utils";

class sluggishCategoryStore {
    @observable list  //主列表数据
    @observable pagination  //主列表分页
    @observable loading  //loading
    @observable searchFields  //搜索表单绑定
    @observable editVisible  //修改框是否显示属性
    @observable editFields  //修改回显字段
    @observable confirmLoading  //修改确认
    @observable showDrawer
    @observable endOpen
    @observable editModalStatus   //修改模态框

    @observable editType  //新增模态框类型


    constructor() {
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.loading=false
        this.searchFields = {
            sparePartName:'',
            classification:'',
        }
        this.editVisible = false
        this.editFields = {
            classification:'',
            sparePartName:'',
        }
        this.confirmLoading = false
        this.showDrawer = false
        this.endOpen = false
        this.modelStatus = false
        this.editModalStatus = false
        this.editType=''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /*** 页面初始化*/
    @action
    initPage = async (page) => {
        this.loading = true
        this.carSeries=''
        let searchFields = {
            sparePartName: this.searchFields.sparePartName ? this.searchFields.sparePartName : '',
            classification: this.searchFields.classification ? this.searchFields.classification : '',
        }
        let search = handleSearchAndPage(page, this.pagination, searchFields)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dullAndSluggish/queryListByPage`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }


    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields, fields) => {
        this[fields] = {...this[fields], ...changedFields}
    }

    /*** 绑定主页面搜索框值****/
    @action
    onEditFormField = (changeFields, fields) => {
        const change = ValueObjToObj(changeFields)
        this[fields] = {...this[fields], ...change}
    }

    /***导出*/
    @action
    getUrl = () => {
        const url = `${process.env.REACT_APP_API_URL}/onestep/base/customerService/dullAndSluggish/exportExcel`
        return `${url}?${_encodeParam()}`
    }

    /*** 清空搜索框*/
    @action
    clearForm = () => {
        this.searchFields = {}
        this.initPage()
    }

    /**打开修改***/
    @action
    editModal = async (type,record) => {
        this.editType = type
        if(this.editType === '新增'){
            runInAction(() => {
                this.editFields = {}
                this.editModalStatus = true
            })
        }else{
            runInAction(() => {
                this.editFields = record
                this.editModalStatus = true
            })
        }

    }

    /****确认修改**/
    @action
    saveEdit = async () => {
        this.confirmLoading = true
        let  res ={}
        if(this.editType === '新增'){
            res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dullAndSluggish/add`, this.editFields)
        }else{
            res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dullAndSluggish/update`, this.editFields)
        }
        if (res.status) {
            runInAction(() => {
                message.success(`${this.editType}成功`)
                this.editVisible = false
                this.editModalStatus = false
                this.confirmLoading = false
            })
            this.initPage(this.pagination.current)
        } else {
            runInAction(() => {
                this.confirmLoading = false
                message.error(`${this.editType}失败`)
            })
        }
    }

    /**删除***/
    @action
    deleteRow = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dullAndSluggish/delById/id/${id}`)
        if (res.status === 1) {
            message.success(res.data)
        } else {
            message.warn(res.msg)
        }
        this.initPage()
    }

    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /***
     * 关闭抽屉
     */
    @action
    onClose = () => {
        this.showDrawer = false
    }


}

export default new sluggishCategoryStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/SluggishCategory/store.js